import React from "react";
import {
  Grid,
  Card,
  Box,
  Typography,
  Chip,
  Button
} from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const WorkOrdersList = ({ workOrders, statuses, navigate }) => {
  const theme = useTheme();

  const getStatusInfo = (statusName) => {
    return statuses.find((s) => s.statusname === statusName);
  };

  if (!workOrders || workOrders.length === 0) {
    return <Typography>No work orders found for this member.</Typography>;
  }

  return (
    <Grid container spacing={2}>
      {workOrders.map((order) => {
        const statusInfo = getStatusInfo(order.status);
        const IconComponent = statusInfo?.icon && MuiIcons[statusInfo.icon];

        const borderColor = statusInfo?.color
          ? theme.palette[statusInfo.color]?.main || statusInfo.color
          : order.resolved_at
          ? "#4caf50"
          : "#f44336";

        return (
          <Grid item xs={12} key={order.order_id}>
            <Card
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 2,
                borderLeft: `8px solid ${borderColor}`,
                borderRadius: 2,
                boxShadow: 3,
                backgroundColor: "#fff",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                {/* Left Side */}
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    WO-{order.order_id}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 1 }}>
                    {order.description || "No description available"}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Created: {new Date(order.created_at).toLocaleDateString()}
                  </Typography>
                </Box>

                {/* Right Side */}
                <Box display="flex" alignItems="center" gap={2}>
                  {IconComponent && (
                    <IconComponent fontSize="small" color={statusInfo?.color || "action"} />
                  )}
                  <Chip
                    label={statusInfo?.statusname || "Unknown"}
                    color={statusInfo?.color || "default"}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => navigate(`/home/workorders/${order.order_id}`)}
                  >
                    View Details
                  </Button>
                </Box>
              </Box>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default WorkOrdersList;
